<template>
  <div class="home-container">
    <!-- 顶部轮播 -->
    <swiper-info :list="list"></swiper-info>
    <!-- 精品项目 -->
    <p class="section-title-line">
      <span>精品项目</span>
    </p>
    <div class="center-container-wrap">
      <div
        class="section-container wow animate__fadeIn"
        data-wow-duration="500ms"
      >
        <img src="../../../assets/images/home/1.jpg" alt="" />

        <div
          class="info-wrap wow animate__slideInUp"
          data-wow-duration="500ms"
          data-wow-delay="100ms"
        >
          <p class="title">新希望·D10天府</p>
          <p class="sub-title">市中心·太古里旁·中国建筑新地标</p>
        </div>
      </div>
    </div>

    <!-- 匠心巨著 -->
    <p class="section-title-line">
      <span>匠心巨著</span>
    </p>
    <div class="center-container-wrap">
      <div class="section-container">
        <el-row :gutter="10">
          <el-col :span="12">
            <div class="flex-container">
              <div class="wow animate__fadeIn" data-wow-duration="500ms">
                <img src="../../../assets/images/home/2.jpg" alt="" />
              </div>
              <div
                class="flex-info-wrap wow animate__slideInUp"
                data-wow-duration="500ms"
                data-wow-delay="100ms"
              >
                <p class="flex-title"><span>D10天系</span></p>
                <p class="sub-desc">城央之上 名门尊邸</p>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="flex-container">
              <div class="wow animate__fadeIn" data-wow-duration="500ms">
                <img src="../../../assets/images/home/3.jpg" alt="" />
              </div>
              <div
                class="flex-info-wrap wow animate__slideInUp"
                data-wow-duration="500ms"
                data-wow-delay="100ms"
              >
                <p class="flex-title"><span>锦麟系</span></p>
                <p class="sub-desc">时代精英的城市华宅</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 最新动态 -->
    <p class="section-title-line">
      <span>最新动态</span>
    </p>

    <pull-refresh-list :list="newsList"></pull-refresh-list>
  </div>
</template>
<script>
import SwiperInfo from "@/components/swiperInfo";
import PullRefreshList from "@/components/pullRefreshList";

export default {
  name: "HomePage",
  components: {
    SwiperInfo,
    PullRefreshList,
  },
  data() {
    return {
      list: [
        {
          url: require("../../../assets/images/home/banner1.jpg"),
          link: "",
        },
        {
          url: require("../../../assets/images/home/banner2.jpg"),
          link: "",
        },
        {
          url: require("../../../assets/images/home/banner3.jpg"),
          link: "",
        },
        {
          url: require("../../../assets/images/home/banner4.jpg"),
          link: "",
        },
        {
          url: require("../../../assets/images/home/banner5.jpg"),
          link: "",
        },
      ],

      newsList: [
        {
          type: '集团新闻',
          title: '新希望入榜2023年《财富》世界500强 位列363位',
          time: '2023/08/02',
          cover: require('../../../assets/images/upload/1.jpg'),
          id: 1
        },
        {
          type: '地产动态',
          title: '要闻丨新希望地产获得中国产业资源战略峰会7项殊荣',
          time: '2023/08/03',
          cover: require('../../../assets/images/upload/2.jpg'),
          id: 2
        },
        {
          type: '地产动态',
          title: '种下希望，收获成长｜2023希苗计划公益游学活动圆满落幕',
          time: '2023/08/21',
          cover: require('../../../assets/images/upload/3.jpg'),
          id:3
        }
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
      // 手动触发滚动事件
      const event = new Event("scroll");
      window.dispatchEvent(event);
    });
  },
};
</script>
<style lang="scss" scoped>
.home-container {
  .section-container {
    .info-wrap {
      width: 400px;
      height: 200px;
      position: absolute;
      left: 50%;
      top: 43%;
      margin-top: -100px;
      margin-left: -200px;
      color: #fff;
      text-align: center;
      background-color: transparent;
    }

    .title {
      font-size: 28px;
      margin-bottom: 15px;
      line-height: 40px;
    }

    .sub-title {
      font-size: 16px;
      text-align: center;
      line-height: 28px;
    }
  }

  .flex-container {
    overflow: hidden;
    position: relative;

    img {
      width: 100%;
      transition: transform 0.6s ease; /* 设置图片的过渡效果 */
    }

    &:hover img {
      transform: scale(1.06);
    }
  }

  .flex-info-wrap {
    position: absolute;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.55);
    transition: all ease-in-out 0.5s 0s;
    top: 50%;
    left: 50%;
    margin-left: -150px;
    margin-top: -55px;
    width: 300px;
    height: 110px;
    box-sizing: border-box;
    padding-top: 30px;
  }

  .flex-title {
    display: block;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 10%;
      width: 20%;
      border-bottom: 1px solid #fff;
    }

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      right: 10%;
      width: 20%;
      border-bottom: 1px solid #fff;
    }

    > span {
      line-height: 25px;
      display: block;
      font-size: 20px;
      color: #fff;
      position: relative;
    }
  }

  .sub-desc {
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: #fff;
    margin-top: 5%;
  }
}
</style>
